import dayjs from 'dayjs';
import 'dayjs/locale/ka';
import 'dayjs/locale/ru.js';
import 'dayjs/locale/uk.js';
export const DEFAULT_FORMAT = 'ddd MMM DD YYYY';
export const getCurrentDate = () => dayjs();
export const getDateDifferenceInSeconds = (firstDate, secondDate) => {
    return getDateDifference(firstDate, secondDate) / 1000;
};
export const getDateDifferenceInDays = (firstDate, secondDate) => {
    return getDateDifference(firstDate, secondDate) / 86400000;
};
export const clearDateUnit = (initialDate = getCurrentDate(), unit = 'second') => {
    return initialDate.startOf(unit);
};
export const getDate = (time, format, strict) => dayjs(time, format, strict);
// usage example: getDateFromString('23.12.1997', '.');
export const getDateFromString = (dateString, separator) => {
    const splittedDateStr = dateString.split(separator);
    if (splittedDateStr.length !== 3)
        return {
            isValid: false,
            date: null,
        }; // day, month, year
    const [day, month, year] = splittedDateStr;
    const yearToApply = year.length === 4 ? year : '20' + year;
    const date = new Date(+yearToApply, +month - 1, +day);
    const dateValid = isDateValid(date);
    return {
        isValid: dateValid,
        date: getNativeDateObject(getDate(date)),
    };
};
export const isDateValid = (date) => getDate(date).isValid();
export const isDateFormatValid = (dateFormat, format) => getDate(dateFormat, format).isValid();
export const getDateDifference = (firstDate, secondDate) => {
    return getDate(firstDate).diff(getDate(secondDate));
};
export const formatDate = (format = DEFAULT_FORMAT, time = getCurrentDate()) => {
    const date = getDate(time);
    if (localStorage.getItem('language') === 'ua') {
        return date.locale('uk').format(format);
    }
    return date.locale(localStorage.getItem('language') || 'en').format(format);
};
export const getNativeDateObject = (date) => dayjs(date).toDate();
export const getMilliseconds = (date) => {
    return getDate(date).valueOf();
};
export const isDateBefore = (firstDate, secondDate) => getDate(firstDate).isBefore(secondDate);
export const addDays = (date, days) => {
    const addedDays = dayjs(date).subtract(days, 'days');
    return getNativeDateObject(addedDays);
};
export const reduceDays = (date, days) => {
    const reducedDay = dayjs(date).subtract(days, 'day');
    return reducedDay;
};
export const setTime = (date, time) => {
    return dayjs(formatDate('YYYY/MM/DD', dayjs(date)) + ` ${time}`);
};
export const getUtcDate = (date) => {
    const formattedDate = dayjs(date);
    const utc = formattedDate.utcOffset() / 60;
    return formattedDate.add(utc, 'hour').toString();
};
export const getDateDifferenceFromCurrentDate = (dateUnit, date) => {
    const targetDate = dayjs(date);
    const currentDate = getCurrentDate();
    return targetDate.diff(currentDate, dateUnit);
};
//# sourceMappingURL=date.js.map